export const COLUMNS: string[] = [
	'pages.drivers.username', 'pages.drivers.firstName', 'pages.drivers.lastName', 'pages.drivers.phone',  '',
];

export const SELECTORS: string[] = [
	'username', 'first_name', 'last_name', 'telephone',
];
